import React, { FC } from "react";
import { ShoppingBagIcon } from "@heroicons/react/24/solid";
import { useCartDataProvider } from "context/CartProductContext";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";

const FloatingCartBar: FC = () => {
  const { Products, itemCount, subtotal, openCartDrawer } =
    useCartDataProvider();
  const location = useLocation();
  const merchantname = Cookies.get("merchantname");

  if (!merchantname || Products.length === 0) return null;

  // Hide on checkout, cart, product-detail (edit flow), and auth pages
  const hiddenExactPaths = [
    `/${merchantname}/checkout`,
    `/${merchantname}/cart`,
    `/${merchantname}/login`,
    `/${merchantname}/signup`,
  ];
  if (hiddenExactPaths.some((path) => location.pathname === path)) return null;
  if (location.pathname.startsWith(`/${merchantname}/product-detail/`)) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-40 lg:hidden animate-slide-up"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <button
        onClick={openCartDrawer}
        className="w-full flex items-center justify-between px-4 py-3 bg-primary-600 dark:bg-primary-500 text-white shadow-lg shadow-primary-600/30 dark:shadow-primary-500/30"
      >
        <div className="flex items-center gap-3">
          <div className="relative">
            <ShoppingBagIcon className="w-6 h-6" />
            <span className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-white dark:bg-slate-900 text-primary-600 dark:text-primary-400 text-[10px] font-bold rounded-full flex items-center justify-center">
              {itemCount}
            </span>
          </div>
          <span className="font-semibold text-sm">View Cart</span>
        </div>
        <span className="font-bold text-base">
          ${subtotal.toFixed(2)}
        </span>
      </button>
    </div>
  );
};

export default FloatingCartBar;
